import { combineReducers } from 'redux';
// import optionLayouts from './option-layouts/reducer'
import global from './global/reducer';
import notifications from './notifications/reducer';

import { default as sellerDocumentTypes } from './seller/document-types/reducer';
import projectOverview from './seller/project-overview/reducer';
import { default as sellerSidebar } from './seller/sidebar/reducer';

import budget from './buyer/budget/reducer';
import changeRequests from './buyer/changeRequests/reducer';
import commentThreads from './buyer/commentThreads/reducer';
import meetings from './buyer/meetings/reducer';
import projectData from './buyer/project-data/reducer';

import { default as buyerDocumentTypes } from './buyer/document-types/reducer';
import landingPage from './buyer/landing-page/reducer';

import { default as buyerPermissions } from './buyer/permissions/reducer';
import { default as buyerSidebar } from './buyer/sidebar/reducer';
import { default as messageDismissals } from './message-dismissals/reducer';

const appReducer = combineReducers({
    buyer: combineReducers({
        sidebar: buyerSidebar,
        documentTypes: buyerDocumentTypes,
        projectData,
        landingPage,
        meetings,
        budget,
        permissions: buyerPermissions,
        commentThreads,
        changeRequests,
    }),
    seller: combineReducers({
        sidebar: sellerSidebar,
        documentTypes: sellerDocumentTypes,
        projectOverview,
    }),
    global,
    messageDismissals,
    notifications,
});

const rootReducer = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
        state = undefined;
    }

    return appReducer(state, action);
};

export default rootReducer;
